<ng-container *ngIf="generalSettingsData">
  <div class="account-img" [matMenuTriggerFor]="menu">
    <img
      src="{{
        generalSettingsData.userDetails.studentPicture
      }}"
      width="46"
      height="46"
      alt="avatar"
    />
    <div class="dropdown-icon">
      <mat-icon [svgIcon]="'arrow-down'" class="square-icon dropdown-arrow"></mat-icon>
    </div>
  </div>

  <mat-menu #menu="matMenu" class="account-info-dropdown-container">
    <div class="user-top-section">
      <div class="avatar-container">
        <img
          src="{{
            generalSettingsData.userDetails.studentPicture
          }}"
          width="46"
          height="46"
          alt="avatar"
        />
      </div>
      <div class="user-name-container">
        <span>{{generalSettingsData.userDetails.name}}</span>
        <a 
          *ngIf="generalSettingsData.portalGeneralSettingsData.accountSettingsLink && (generalSettingsData.userDetails.userType === 0 || generalSettingsData.userDetails.userType === 2)"
          [href]="generalSettingsData.portalGeneralSettingsData.accountSettingsLink.url"
          [target]="generalSettingsData.portalGeneralSettingsData.accountSettingsLink.target">
          {{generalSettingsData.portalGeneralSettingsData.accountSettingsLink.title}}
        </a>
      </div>
    </div>

    <ng-container *ngIf="generalSettingsData.userDetails.userType === 0 || generalSettingsData.userDetails.userType === 2">
      <button 
        *ngIf="generalSettingsData.userDetails.sessionSiteViewType === 1"
        (click)="changeSessionView('StaffMember')" mat-menu-item
        class="account-info-button switch-session-type">
        <img [src]="generalSettingsData.portalGeneralSettingsData.accountSettingsChangeSiteTypeIconUrl" class="account-info-button-icon"/>
        {{ generalSettingsData.portalGeneralSettingsData.portalMenuStaffTitle }}
      </button>
      <button 
        *ngIf="generalSettingsData.userDetails.sessionSiteViewType === 2"
        (click)="changeSessionView('Student')" mat-menu-item
        class="account-info-button switch-session-type">
        <img [src]="generalSettingsData.portalGeneralSettingsData.accountSettingsChangeSiteTypeIconUrl" class="account-info-button-icon"/>
        {{
          generalSettingsData.portalGeneralSettingsData.portalMenuStudentTitle
        }}
      </button>

      <button
        (click)="openAccountSettingsPopup()" mat-menu-item
        class="account-info-button"
        *ngIf="generalSettingsData.userDetails.sessionSiteViewType === 1">
        <img [src]="generalSettingsData.portalGeneralSettingsData.accountSettingsOpenSettingsPopupIconUrl" class="account-info-button-icon"/>
        {{
          generalSettingsData.portalGeneralSettingsData.accountSettingsOpenSettingsPopupText
        }}
      </button>
    </ng-container>

    <button
      (click)="onLogout()" mat-menu-item
      class="account-info-button logout-button">
      <img [src]="generalSettingsData.portalGeneralSettingsData.accountSettingsLogoutIconUrl" class="account-info-button-icon"/>
      {{
        generalSettingsData.portalGeneralSettingsData.logoutLinkText
      }}
    </button>
  </mat-menu>
</ng-container>

<ng-container *ngIf="!generalSettingsData">
  <div class="account-img" aria-hidden="true" >
    <app-skeleton [height]="46" [width]="46" [borderRadius]="'50%'"/>
  </div>

  <div class="account-info" aria-hidden="true" >
    <div class="info-label">
      <app-skeleton [symbolsCount]="7" type="text"/>
    </div>
    <div class="no-style name" aria-hidden="true" >
      <app-skeleton [symbolsCount]="10" type="text"/>
    </div>
  </div>

  <div class="logout-link" aria-hidden="true"><app-skeleton [symbolsCount]="6" type="text"/></div>
</ng-container>
